<template>
  <div class="device-selection">
    <el-select
      class="theme-selection"
      v-model="activeColorTheme"
      popper-class="device__sub-select theme"
    >
      <el-option
        v-for="(item, idx) in colorOptions"
        :key="idx"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { toggleBodyClass, store } from '@/utils/common';
import { SET_MYSTAGE_THEME } from '@/graphql/mutations/userSetting';
import { apolloProvider } from '@/modules/myStageGraphQL';
import logger from '@/modules/Logger';

export default {
  data() {
    return {
      // 
    };
  },
  mounted() {
    toggleBodyClass(this.isColorSchemeDark);
  },
  computed: {
    ...mapState('layout', ['layoutColor']),
    ...mapGetters('layout', ['isColorSchemeDark']),

    colorOptions() {
      return [
        {
          label: this.$t(`sideMenu.color.light`),
          value: 'light'
        },
        {
          label: this.$t(`sideMenu.color.dark`),
          value: 'dark'
        }
      ];
    },

    activeColorTheme: {
      get: function() {
        return this.layoutColor;
      },
      set: function(newValue) {
        this.switchColor(newValue);
      }
    }
  },
  methods: {
    ...mapActions('layout', ['switchLayoutColor']),

    async switchColor(color) {
      store.setColor(color);
      this.switchLayoutColor(color);
      toggleBodyClass(this.isColorSchemeDark);

      const themeValue = color === 'dark' ? 2 : 1;
      try {
        await apolloProvider.defaultClient.mutate({
          mutation: SET_MYSTAGE_THEME,
          variables: { color: themeValue }
        });
      } catch (error) {
        logger.error('[ThemeSelection] Failed to persist theme', {
          operation: 'user:setMystageTheme',
          error: error.message
        });
      }
    }
  }
};
</script>

<style scoped src="@/assets/css/pc/device_selection.css"></style>
<style scoped src="@/assets/css/pc/side_menu.css"></style>
